import { BigNumber } from 'bignumber.js/bignumber';

type strOrNum = string | number;

export const getValueWithDecimals = (amount: strOrNum, decimals: strOrNum): any => {
  return new BigNumber(amount).multipliedBy(new BigNumber(10).pow(decimals)).toString(10);
};
